import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
//import _ from 'lodash'
//import Button from '@material-ui/core/Button'

const styles = theme => ({
    paper: {
        padding: theme.spacing.unit,
      },
      rowContent: {
        marginBottom: '0.8em',
        padding: '0.2em',
        borderBottom: '2px solid #3f51b5',
        
    
    },
})

const RequesterDetails = (props) =>{
    const { classes, requester } = props
    return (
        <Paper className={classes.paper}>
            <Typography variant="headline" color='primary' gutterBottom>
                    Mitglied
            </Typography>
            {requester
                ?<div>
                    <Typography variant='subheading'>
                        <div  className={classes.rowContent}>{requester.name}</div>
                        <div  className={classes.rowContent}>{requester.strasse}</div>
                        <div  className={classes.rowContent}>{requester.ort}</div>
                        <div  className={classes.rowContent}>{requester.email}</div>
                        <div  className={classes.rowContent}>{requester.telefon}</div>
                    </Typography>
                    <div>

                    </div>
                </div>
                : <div  className={classes.rowContent}> Wählen Sie einen Bewerber</div>
            }
        </Paper>
    )
}

const mapStateToProps = (state) =>({
    requester: state.adminCanidateState.currentOpenEvent.requester
})
export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(RequesterDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminEventDetails/RequesterDetails.js